module.exports = __webpack_public_path__ + "img/r-173.bcc77026.jpg";